import formatPhoneNumber from "../../../../../helpers/formatephoneNumber";
import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

export const recoveryPlanCols = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Insurance Claim Procedures": [
      { title: "Policy", dataIndex: "Policy", key: "policy" },
      { title: "Procedure", dataIndex: "Procedure", key: "policyprocedure" },
      actionColumn,
    ],
    "Contractor Contacts": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Specialty",
        dataIndex: "Specialty",
        key: "specialty",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
        render: (record) => (record ? formatPhoneNumber(record) : "N/A"),

      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Restoration Services": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Specialty",
        dataIndex: "Specialty",
        key: "specialty",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phone number",
        render: (record) => (record ? formatPhoneNumber(record) : "N/A"),

      },
      {
        title: "Notes",
        dataIndex: "Notes",
        key: "notes",
        render: (record) => (record ? record : "N/A"),
      },

      actionColumn,
    ],
  };
};
